
ActivityReportBaseController = ($controller, $scope, program, activityTypes, ApiUrl) ->
    "ngInject"

    @program = program

    @activityTypes = activityTypes
    emitter = $controller 'TagRefreshEmitter', $scope: $scope
    angular.extend @, emitter

    url = ApiUrl.partial('report', 'activity')
    url = url.partial(program.id) if program?

    $scope.$on 'tagRefresh', (event, params) =>
        tags = buildDownloadURL(params)
        @downloadUrl = url('activities.xlsx') + '?' + tags
        return

    return

ActivityOverviewController = ($scope, $http, activityTypes, Debouncer, ApiUrl, program) ->
    "ngInject"

    url = ApiUrl.partial('report', 'activity')
    url = url.partial(program.id) if program?

    @data = {}
    @activityTypes = activityTypes
    @params = null


    $scope.$emit 'requestTagParams'

    $scope.$on 'tagRefresh', (event, params) =>
        @params = params
        refresh.call()

    refresh = new Debouncer =>
        $http.get(url(), params: @params)
            .then setData

    setData = (response) =>
        @students = response.data.student_count or 0
        @programs = response.data.program_count or 0
        for type in @activityTypes
            num = response.data.activities[type] or 0
            @data[type] = @data[type] or [0, 1]
            @data[type][0] = num
            @data[type][1] = @students - num
            if num == 0 and @students == 0
                @data[type][1] = 1
        return

    return


ActivityDetailsController = ($scope, $state, $http, $stateParams,
                             activityTypes, mentoringTypes, program,
                             Debouncer, ApiUrl) ->
    'ngInject'

    @activityTypes = activityTypes;
    @type = $stateParams.type
    @mentoringTypes = mentoringTypes if @type == 'mentoring'
    @loading = true

    url = ApiUrl.partial('report', 'activity', @type)
    url = url.partial(program.id) if program?

    @tags = {}
    @sort = $stateParams.sort
    @page = $stateParams.page

    $scope.$emit 'requestTagParams'
    $scope.$on 'tagRefresh', (event, params) =>
        @tags = params
        @refresh.call()

    @makeParams = (base) ->
        base.type = @type
        angular.extend(base, @tags)
        return base

    @refresh = new Debouncer =>
        @loading = true
        params = angular.copy @tags
        params.sort = @sort
        params.page = @page
        $state.go('.', params, location: 'replace')
        $http.get(url(), params: params).then(setData)

    setData = (response) =>
        @items = response.data.items
        @totals = response.data.totals
        @pager = response.data.pager
        @maxNumerator = findMax(@items, 'numerator')
        @maxDenominator = findMax(@items, 'denominator')
        @loading = false

    findMax = (items, field) ->
        get = (val, item) ->
             if item[field] and val < item[field] then item[field] else val
        return items.reduce get, 0

    return


buildDownloadURL = (tags) ->
    parts = []
    for slug of tags
        for tag in tags[slug]
            parts.push "#{slug}=#{encodeURIComponent(tag)}"
    return parts.join('&')


module
    .controller 'ActivityReportBaseController', ActivityReportBaseController
    .controller 'ActivityOverviewController', ActivityOverviewController
    .controller 'ActivityDetailsController', ActivityDetailsController
